export const defaultPreChatSurveyPaneMultichoiceInputStyles = {
  fontFamily: "Segoe UI, Helvetica Neue, sans-serif"
};